import _ from 'underscore';
import { FCAAccountDomainStatus } from './constants';

export const MTDomainDataToUI = ({ CleansedDomain, Status }) => ({
  cleansedDomain: CleansedDomain, status: Status,
});

export const getDomainsToMT = domainData => _.map(domainData, d => ({ CleansedDomain: d.cleansedDomain, Status: d.status || FCAAccountDomainStatus.Create }));
